import classNames from 'classnames'
import PubSub from 'pubsub-js'
import React, { useEffect, useState } from 'react'

import Geocoder from '@js/common/geocoder'
import User from '@js/common/user'
import { formatNumber } from '@js/common/utils'

import CTA from '@f/elements/CTA'
import Icon from '@f/elements/Icon'

const SearchResultsFiltersBar = props => {
  const [deliveryRegionsLabel, setDeliveryRegionsLabel] = useState(
    User.getLocation().label
  )

  useEffect(() => {
    if (
      props.params.delivery_regions__in &&
      !User.getLocation().label &&
      props.restrictTo === 'delivery_regions'
    ) {
      let geocoder = new Geocoder()
      geocoder.getLocationFromPostcode(props.params.delivery_regions__in).then(
        data => {
          setDeliveryRegionsLabel(data.label)

          User.setLocation(data)
          PubSub.publish('QUERYUPDATE', {
            field: 'delivery_regions__in',
            ...data
          })
        },
        () => {}
      )
    }

    pbQueryupdate = PubSub.subscribe('QUERYUPDATE', () => {
      setDeliveryRegionsLabel(User.getLocation().label)
    })
  }, [])

  let pbQueryupdate
  useEffect(() => {
    PubSub.subscribe('QUERYUPDATE', () => {
      setDeliveryRegionsLabel(User.getLocation().label)
    })

    return () => {
      PubSub.unsubscribe(pbQueryupdate)
    }
  }, [])

  useEffect(() => {
    setDeliveryRegionsLabel(User.getLocation().label)
  }, [props.delivery_regions__in])

  let filters = []

  for (let filter in props.filters) {
    const name = filter.split('__')[0]

    if (filter.indexOf('price') > -1) {
      let priceSlider = props.availableFilters.find(
        filter => filter.name == 'price'
      )
      let expansionStage = props.availableFilters.find(
        filter => filter.name == 'expansion_stage'
      )

      if (priceSlider) {
        let priceSliderValue = props.filters[filter].split(',').map(el => {
          if (el != '' && !isNaN(el)) {
            let formattedNumber = formatNumber(
              el,
              el % 1 != 0 ? 1 : 0,
              ',',
              '.'
            )
            return formattedNumber
          }

          return ''
        })

        if (priceSliderValue.length > 0) {
          if (priceSliderValue[0] === '') {
            priceSliderValue = `< ${priceSliderValue[1]}`
          } else if (priceSliderValue[1] === '') {
            priceSliderValue = `> ${priceSliderValue[0]}`
          } else {
            priceSliderValue = priceSliderValue.join(' - ')
          }
        }

        filters.push({
          id: 'price',
          value: `${priceSliderValue} ${priceSlider.suffix}`,
          name: filter,
          default: 'price__range'
        })
      }

      if (name != expansionStage.default) {
        filters.push({
          id: 'expansion_stage',
          value: expansionStage.values.find(el => el.id == name).name,
          name: filter,
          default: 'price__range'
        })
      }
    } else {
      let currentFilter = props.availableFilters.find(
        filter => filter.name == name
      )
      let currentValue

      if (/target_groups__in/.test(filter)) {
        currentFilter = filter
      }

      if (!currentFilter) {
        continue
      }

      if (currentFilter.type === 'range') {
        currentValue = props.filters[filter].split(',').map(el => {
          if (el != '' && !isNaN(el)) {
            let formattedNumber = formatNumber(
              el,
              el % 1 != 0 ? 1 : 0,
              ',',
              '.'
            )
            return formattedNumber
          }

          return ''
        })

        if (currentValue.length > 0) {
          if (currentValue[0] === '') {
            currentValue = `< ${currentValue[1]}`
          } else if (currentValue[1] === '') {
            currentValue = `> ${currentValue[0]}`
          } else {
            currentValue = currentValue.join(' - ')
          }
        }

        if (currentFilter.suffix) {
          currentValue += ` ${currentFilter.suffix}`
        }

        if (currentFilter.labelSuffix) {
          currentValue += ` ${currentFilter.labelSuffix}`
        }

        filters.push({
          id: props.filters[filter],
          value: currentValue,
          name: filter
        })
      } else {
        const filtersToCheck = props.filters[filter].split(',')

        if (filtersToCheck.length > 1) {
          filters.push({
            id: currentFilter.label,
            value: `${currentFilter.labelPlural} · ${filtersToCheck.length}`,
            name: filter
          })
        } else {
          filtersToCheck.map(value => {
            currentValue =
              (currentFilter &&
                currentFilter.values &&
                currentFilter.values.find(
                  filterValue => filterValue.id == value
                ) &&
                currentFilter.values.find(
                  filterValue => filterValue.id == value
                ).name) ||
              value

            let displayValue = currentValue

            switch (filter) {
              case 'delivery_regions__in':
                displayValue = deliveryRegionsLabel
                break

              case 'target_groups__in':
                let displayValues = {
                  1: 'Senioren',
                  2: 'Kinderreiche',
                  3: 'Junge Familien',
                  4: 'Allergiker',
                  5: 'Mehrgenerationenhaus',
                  6: 'Single',
                  7: 'Barrierefreies Haus',
                  8: 'Ökohaus/Biohaus',
                  9: 'Selber planen'
                }

                displayValue = displayValues[props.filters[filter]]
                break
            }

            filters.push({
              id: value,
              value: displayValue,
              name: filter
            })
          })
        }
      }
    }
  }

  filters = filters.filter(filter => filter.value)

  if (props.restrictTo) {
    filters = filters.filter(filter => {
      if (/price|expansion_stage/.test(el.id)) {
        return filter.id == props.restrictTo
      }
      return filter.name.split('__')[0] == props.restrictTo
    })
  }

  let mainFilters = []

  if (props.type === 'houses') {
    mainFilters =
      props.variant === 'ex_leads'
        ? ['price', 'living_area_total', 'number_rooms', 'form', 'roof_shape']
        : [
            'price',
            'delivery_regions',
            'living_area_total',
            'form',
            'has_floor_plans'
          ]
  }

  if (props.type === 'vendors') {
    mainFilters = [
      'delivery_regions',
      'construction_method',
      'expansion_stage',
      'utilization'
    ]
  }

  mainFilters = mainFilters
    .map(mainFilter => {
      const currentMainFilter = props.availableFilters.find(
        filter => filter.name === mainFilter
      )

      if (currentMainFilter) {
        const activeFilter = filters.find(
          filter =>
            filter.name.indexOf(mainFilter) > -1 ||
            (props.type === 'vendors' && filter.id.indexOf(mainFilter) > -1)
        )
        const isActive = !!activeFilter

        let styles = {}
        let dataSel = ''
        switch (mainFilter) {
          case 'price':
            styles = { maxWidth: 140 }
            dataSel = 'btn-flt-price'
            break
          case 'delivery_regions':
            styles = {
              maxWidth: 'calc(100% - 156px)'
            } /* 130 from the price filter, plus 8px of padding of each side */
            dataSel = 'btn-flt-bo'
            break
          case 'living_area_total':
            styles = {
              maxWidth: 100
            }
            dataSel = 'btn-flt-larea'
            break
          case 'form':
            styles = {
              maxWidth: 120
            }
            dataSel = 'btn-flt-form'
            break
          case 'construction_method':
            styles = {
              maxWidth: 120
            }
            dataSel = 'btn-flt-cm'
            break
          case 'expansion_stage':
            styles = {
              maxWidth: 120
            }
            dataSel = 'btn-flt-exp'
            break
        }
        const toggleFloorPlanListing = () => {
          const { has_floor_plans, ...restOfParams } = props.params
          const newParams = { ...restOfParams }
          if (!has_floor_plans) {
            newParams['has_floor_plans'] = 'true'
          }
          props.updateParams(newParams)
        }

        const triggerPanelDisplay = event =>
          props.displayPanel({
            filter: currentMainFilter.name,
            offsetLeft: event.currentTarget.offsetLeft,
            isActive
          })

        const trackingLabel = (() => {
          if (!currentMainFilter.tracking) return 'filter-type'
          if (isActive) return currentMainFilter.tracking.off
          return currentMainFilter.tracking.on
        })()

        return (
          <CTA
            key={`main_filter_${mainFilter}`}
            type='block-tertiary'
            tag='button'
            className={classNames(
              'f-p-a-010',
              'f-m-a-005',
              'SearchResultsFilters-button',
              { 'is-active': isActive },
              {
                'has-panel-displayed':
                  props.panelDisplayed.filter === currentMainFilter.name
              },
              {
                'SearchResultsFilters-button__with-icon': !!currentMainFilter.iconName
              }
            )}
            data-sel={dataSel}
            onClick={
              mainFilter === 'has_floor_plans'
                ? toggleFloorPlanListing
                : triggerPanelDisplay
            }
            wtData={{
              'CTA-click': {
                label: trackingLabel,
                location: 'filter-panel'
              }
            }}
            style={isActive ? styles : null}>
            {currentMainFilter.iconName && (
              <Icon
                icon={currentMainFilter.iconName}
                className='[ f-icon-020 f-c-st-inherit f-icon-t-mini f-m-r-010 ]'
              />
            )}
            <span className='[ f-d-bl f-p-h-005 f-t-ellip ]'>
              {isActive && currentMainFilter.name !== 'has_floor_plans'
                ? activeFilter.value
                : currentMainFilter.label}
            </span>
          </CTA>
        )
      }
    })
    .filter(Boolean)

  return mainFilters
}

export default SearchResultsFiltersBar
